import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import {
  MatBottomSheet,
  MatBottomSheetRef,
  MAT_BOTTOM_SHEET_DATA,
} from '@angular/material/bottom-sheet';
import { Subscription } from 'rxjs';
import { CookingStoryKitchenDataService } from 'src/app/data/repository/cooking-story/cooking-story-kitchen-data.service';
import { SubmitButtonShared } from 'src/app/presentation/general/shared/submit-button-shared';
import { KitchenSearchEditComponent } from '../kitchen-search-edit.component';

@Component({
  selector: 'app-kitchen-search-date',
  templateUrl: './kitchen-search-date.component.html',
  styleUrls: ['./kitchen-search-date.component.scss'],
})
export class KitchenSearchDateComponent implements OnInit, OnDestroy {
  SWIPE_ACTION = { UP: 'swipeup', DOWN: 'swipedown' };
  subscriptions: Subscription[] = [];

  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA)
    public data: {
      name: string;
    },
    private bottomSheetRef: MatBottomSheetRef<KitchenSearchDateComponent>,
    private matBottomSheet: MatBottomSheet,
    private CookingStoryKitchenDataService: CookingStoryKitchenDataService,
    private submitButtonShared: SubmitButtonShared
  ) {}

  ngOnInit(): void {}
  swipe(action: string = this.SWIPE_ACTION.DOWN) {
    if (action === this.SWIPE_ACTION.DOWN) {
      this.goBack();
    }
  }
  goBack() {
    const bottomSheetRef = this.matBottomSheet.open(
      KitchenSearchEditComponent,
      {
        panelClass: 'custom-bottomsheet-container',
      }
    );
    const sub = bottomSheetRef
      .afterDismissed()
      .subscribe((dataFromChild) => {});
    this.subscriptions.push(sub);
  }
  submit() {
    this.CookingStoryKitchenDataService.submitDate.next(true);
    this.goBack();
  }
  ngOnDestroy() {
    this.subscriptions.forEach((sb) => sb.unsubscribe());
  }
}
